import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useApp } from "../context/AppContext";

const Gallery = () => {
  const { t } = useApp();
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("loading");
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    axios.get("/api/gallery")
      .then(r => { setItems(r.data.items || []); setStatus("ready"); })
      .catch(() => setStatus("error"));
  }, []);

  return (
    <>
      <div className="page-band">
        <div className="container">
          <h1>{t("galleryTitle")}</h1>
          <p>{t("gallerySub")}</p>
        </div>
      </div>

      <section className="section container">
        {status === "loading" && <div className="empty-state">{t("loading")}</div>}
        {status === "error"   && <div className="empty-state">Could not load gallery.</div>}
        {status === "ready" && items.length === 0 && (
          <div className="empty-state">
            <p>{t("noGallery")}</p>
            <Link className="btn btn-primary" to="/register">{t("beFirst")}</Link>
          </div>
        )}

        {/* Masonry grid via CSS columns */}
        {items.length > 0 && (
          <div style={{ columns:"220px", columnGap:12 }}>
            {items.map((item, i) => (
              <div key={i} onClick={() => setLightbox(item)}
                style={{ breakInside:"avoid", marginBottom:12, borderRadius:12, overflow:"hidden",
                         cursor:"pointer", border:"1px solid var(--line)", position:"relative" }}>
                <img src={item.src} alt={item.artistName}
                  style={{ width:"100%", display:"block", background:"var(--brand-soft)" }}
                  onError={e => { e.currentTarget.style.display="none"; }} />
                <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top, rgba(0,0,0,0.65) 0%, transparent 50%)",
                              opacity:0, transition:"opacity 0.2s", display:"flex", alignItems:"flex-end", padding:10 }}
                  className="gal-overlay">
                  <span style={{ color:"#fff", fontSize:"0.8rem", fontWeight:600 }}>{item.artistName}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div onClick={() => setLightbox(null)}
          style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.92)", zIndex:1000,
                   display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:20 }}>
          <button onClick={() => setLightbox(null)}
            style={{ position:"absolute", top:20, right:20, background:"none", border:"none", color:"#fff", fontSize:"2rem", cursor:"pointer" }}>
            <i className="fa-solid fa-xmark" />
          </button>
          <img src={lightbox.src} alt={lightbox.artistName}
            style={{ maxHeight:"82vh", maxWidth:"92vw", borderRadius:12, objectFit:"contain" }}
            onClick={e => e.stopPropagation()} />
          <div style={{ marginTop:16, textAlign:"center" }}>
            <div style={{ color:"#fff", fontWeight:700 }}>{lightbox.artistName}</div>
            {lightbox.specialty && <div style={{ color:"rgba(255,255,255,0.65)", fontSize:"0.9rem" }}>{lightbox.specialty}</div>}
            <Link to={`/artists/${lightbox.artistId}`} style={{ color:"var(--gold)", fontSize:"0.88rem", marginTop:6, display:"inline-block" }}
              onClick={e => e.stopPropagation()}>
              {t("viewProfile")} →
            </Link>
          </div>
        </div>
      )}

      <style>{`.gal-overlay { } div:hover .gal-overlay { opacity: 1 !important; }`}</style>
    </>
  );
};

export default Gallery;
